import Hero from '../../components/Hero/Hero.js';
import Services from '../../components/Benefits/Benefits.js';
import Description from '../../components/Description/Description.js';

export default function Home() {
    return (
        <>
            <Hero/>
            <Services/>
            <Description/>
        </>
    )
}